export default {
  GET_RECITER: 'GET_RECITER'
}



// WEBPACK FOOTER //
// ./src/Reciter/actionTypes.js